/**
 * Default organization branding for HR policy PDFs (confirmation policy, etc.).
 * Align with the primary company configured under Masters / Enterprise.
 */
export const MASTERS_DOCUMENT_COMPANY_NAME = "Paytiemp Smartech Solutions";
export const MASTERS_DOCUMENT_COMPANY_ADDRESS = "";
